import { dia, ui } from '@joint/plus';
import { operators } from './yamazumi-3d/data';
import { Yamazumi3D } from './yamazumi-3d/yamazumi-3d';
import { RectPrism, RectPrismView } from './yamazumi-3d/shapes/rect-prism';
import { TaskElement, TaskElementView } from './yamazumi-3d/shapes/task-element';
import { BottomElement, BottomElementView } from './yamazumi-3d/shapes/bottom-element';
var yamazumiShapes = {
    yamazumi: {
        RectPrism: RectPrism,
        RectPrismView: RectPrismView,
        BottomElement: BottomElement,
        BottomElementView: BottomElementView,
        TaskElement: TaskElement,
        TaskElementView: TaskElementView
    }
};
export var init = function () {
    var graph = new dia.Graph({}, { cellNamespace: yamazumiShapes });
    var paper = new dia.Paper({
        el: document.getElementById('paper'),
        width: 1000,
        height: 650,
        model: graph,
        drawGrid: { name: 'mesh', color: '#d4d4d4' },
        background: { color: '#FBFBFB' },
        moveThreshold: 10,
        clickThreshold: 10,
        async: true,
        cellViewNamespace: yamazumiShapes,
        interactive: false,
    });
    paper.on('cell:pointerdown', function (view, evt) {
        if (!view.isDefaultInteractionPrevented(evt)) {
            var el = document.activeElement;
            el.blur();
        }
    });
    paper.on('cell:pointermove', function (view) {
        view.el.classList.add('dragging');
        paper.hideTools();
    });
    paper.on('cell:pointerup', function (view) {
        view.el.classList.remove('dragging');
        paper.showTools();
    });
    paper.on('blank:pointerdown', function () {
        var el = document.activeElement;
        el.blur();
    });
    var yamazumi = new Yamazumi3D({
        paper: paper,
        topLeft: {
            x: 100,
            y: 60
        },
        maxDuration: 70,
        height: 530,
        operators: operators,
    });
    var acceptCommandsList = ['change:stackIndex', 'change:stackElementIndex', 'change:duration', 'remove'];
    var cmd = new dia.CommandManager({
        graph: graph,
        cmdBeforeAdd: function (cmdName) {
            if (acceptCommandsList.includes(cmdName)) {
                return true;
            }
            return false;
        }
    });
    cmd.on('stack:undo stack:redo', function () {
        yamazumi.layoutView.model.update();
    });
    var toolbar = new ui.Toolbar({
        el: document.getElementById('toolbar'),
        tools: ['undo', 'redo'],
        autoToggle: true,
        references: { commandManager: cmd }
    });
    toolbar.render();
};
